import React, { createElement } from 'react';
// Module-level side effect: runs BEFORE React mounts.
if (typeof document !== 'undefined') {
  const head = document.head;
  const ensureLink = (rel: string, href: string, attrs: Record<string, string> = {}) => {
    if (head.querySelector(`link[rel="${rel}"][href="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
    head.appendChild(link);
  };
  // Preconnect so DNS/TLS happens in parallel with HTML parse
  ensureLink('preconnect', 'https://fonts.googleapis.com');
  ensureLink('preconnect', 'https://fonts.gstatic.com', {
    crossorigin: ''
  });
  ensureLink('preconnect', 'https://images.weserv.nl');
  // Responsive preload of the hero image (LCP element).
  if (!head.querySelector('link[rel="preload"][data-lcp="hero"]')) {
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.setAttribute('as', 'image');
    preload.setAttribute('fetchpriority', 'high');
    preload.setAttribute('type', 'image/webp');
    preload.setAttribute('data-lcp', 'hero');
    preload.href = 'https://images.weserv.nl/?url=cdn.magicpatterns.com/uploads/hJoBWeJMG3L5mE4YhJupcS/mocap_volleybool.webp&w=320&output=webp&q=50';
    preload.setAttribute('imagesrcset', ['https://images.weserv.nl/?url=cdn.magicpatterns.com/uploads/hJoBWeJMG3L5mE4YhJupcS/mocap_volleybool.webp&w=320&output=webp&q=50 320w', 'https://images.weserv.nl/?url=cdn.magicpatterns.com/uploads/hJoBWeJMG3L5mE4YhJupcS/mocap_volleybool.webp&w=480&output=webp&q=60 480w', 'https://images.weserv.nl/?url=cdn.magicpatterns.com/uploads/hJoBWeJMG3L5mE4YhJupcS/mocap_volleybool.webp&w=800&output=webp&q=72 800w'].join(', '));
    preload.setAttribute('imagesizes', '(max-width: 640px) 92vw, (max-width: 1024px) 60vw, 500px');
    head.appendChild(preload);
  }
  // SINGLE FONT only — Inter 400/700. Dropped Bai Jamjuree entirely (~25KB saved).
  // Display headings now use the same Inter at 700 weight for a unified, faster load.
  if (!head.querySelector('link[data-fonts="google"]')) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap';
    fontLink.media = 'print';
    fontLink.setAttribute('data-fonts', 'google');
    fontLink.onload = function () {
      ;
      (fontLink as HTMLLinkElement).media = 'all';
    };
    head.appendChild(fontLink);
    setTimeout(() => {
      if ((fontLink as HTMLLinkElement).media !== 'all') {
        ;
        (fontLink as HTMLLinkElement).media = 'all';
      }
    }, 3000);
  }
}
export function PreloadAssets() {
  return null;
}